<template>
  <div class="input-group">
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12">
        <v-text-field
          id="vxmlName"
          v-model="node.name"
          label="Name"
          hide-details
        >
        </v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12">
        <div>Payload</div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12" class="p-t-0">
        <v-textarea
          id="vxmlCondition"
          class="textarea-input"
          v-model="property.payload"
          placeholder="CODE"
          solo
          hide-details
          rows="3"
        ></v-textarea>
      </v-col>
    </v-row>

    <hr class="note-divider" />
    <note-component :node="node" />
  </div>
</template>

<script>
import NoteComponent from '../../../components/note'

export default {
  props: {
    node: Object
  },
  components: {
    NoteComponent
  },
  data() {
    return {
      property: {}
    }
  },
  created() {
    this.property = this.node.property
  }
}
</script>

<style scoped lang="scss">
.body-dialog {
  margin: 10px !important;
}
</style>
